import React, { memo } from 'react'
import { Flex } from '@chakra-ui/core'
import { MessageInput } from '../MessageInput'
import { OptionType } from '../constants'
import { TitleInput } from '../TitleInput'
import keys from 'constants/keys'
import { EditorContent, RichTextEditor } from 'components/CommonComponents/RichTextEditor'

interface IProps {
  selectedOptionType: string
  richTextValue: EditorContent | null
  setRichTextValue: (value: EditorContent | null) => void
  setTitle: (text: string) => void
  title: string
  placeholder: string
  message: string
  setMessage: (text: string) => void
  postType?: number
  isEditing: boolean
}
export const InputBlock = memo(
  ({
    selectedOptionType,
    richTextValue,
    setRichTextValue,
    setTitle,
    title,
    placeholder,
    message,
    setMessage,
    postType,
    isEditing,
  }: IProps) => {
    const richTextEditor = (
      <RichTextEditor
        value={richTextValue}
        onChange={(content) => setRichTextValue(content)}
        placeholder={placeholder}
        containerStyle={{ border: 'none' }}
      />
    )

    if (postType !== undefined) {
      switch (postType) {
        case keys.POST_TYPE.REGULAR:
        case keys.POST_TYPE.LINKED:
          return richTextEditor

        default:
          return (
            <Flex flexDir="column" minH="150px">
              <TitleInput setTitle={setTitle} title={title} selectedOptionType={selectedOptionType} />
              {!isEditing && (
                <MessageInput message={message} setMessage={setMessage} selectedOptionType={selectedOptionType} />
              )}
            </Flex>
          )
      }
    } else {
      switch (selectedOptionType) {
        case OptionType.POST:
          return richTextEditor
        default:
          return (
            <Flex flexDir="column" minH="150px">
              <TitleInput setTitle={setTitle} title={title} selectedOptionType={selectedOptionType} />
              {!isEditing && (
                <MessageInput message={message} setMessage={setMessage} selectedOptionType={selectedOptionType} />
              )}
            </Flex>
          )
      }
    }
  }
)
